var MessageTcc = {
  NavabarText: {
    navbar_home: "主頁",
    navbar_about: "關於我們",
    navbar_search: "查詢報告",
    navbar_contact: "聯絡我們",
    navbar_item: "服務項目",
    navbr_new:'最新消息',

  },
  About_Navbar:{
    Company:'公司簡介',
    Horor:'榮譽與資質',
    Technology:'科研技術',
    Team:'我們的團隊 ',
  },
  Item_NavBar:{
      YC_DNA_Test:'母血Y染色體檢測',
      Non_Prenatal_Test:'無創產前基因檢測',
      Non_Paternity_Test:'親子鑑定(產前或產後)',
      Prenatal_And_Postpartum:'(產前和產後)',
  },
  New_NavBar:{
      Notice:'公司通告',
      MediaCentre:'媒體中心',
  },
  indexText: {
    more: "瞭解更多",

  },
  footText:{
    address:"香港新界火炭坳背灣街2-12號，威力工業中心，9樓N室",
    address_prefix: "香港新界火炭坳背灣街2-12號，",
    address_suffix: "威力工業中心，9樓N室",
    address_prefix1: "香港新界火炭坳背灣街2-12號，威力工業中心，9樓N室",
    phone:"(+852) 3100 0477",
    email:"info@hkmedilab.com",
    weixin:"掃碼關注公眾號",
    aboutUs:'關於我們',
    company:'公司簡介',
    honor:'榮譽與資質',
    technology:'科研技術',
    team:'我們的團隊 ',
    services:'服務項目',
    chromosomeText:'母血Y染色體檢測',
    invasivePrenatalTest:'無創產前基因檢測',
    invasivePaterNityTest:'親子鑑定(產前或產後)',
    special:'(產前和產後)',
    news:'最新消息',
    notice:'公司通告',
    mediaCentre:'媒體中心',
    report:'查詢報告',
    contact:'聯絡我們',
    talentRecruitment:'人才招聘',
    OfficeHours:'營業時間',
    day1:'星期一至五',
    day2:'星期六至日',
    version:'版權所有(c) 2020 香港醫務檢測中心有限公司',
    privacy: '隐私政策',
    terms: '使用条款',
    Links1: '海外導航網',
    back:'返回主頁',
  },
  ContractText:{
    name:'受測者姓名：',
    code:'報告編號：',
    phone:'手機號碼：',
    send_sms:'發送驗證碼',
    send_sms_second:'重新發送',
    vertifys:'輸入驗證碼',
    mailbox_btn:'確認',
    speaker:'備用驗證',
    warning:'本人已閱讀並同意網站的',
    statement:'私隱政策',
    report_search_description:'報告查詢指引：',
    description_one:'網查功能於電子報告發出3小時後提供。',
    description_two:'請確保您輸入的受測者名字及報告編號與收到的報告一致。',
    description_three:'根據指引輸入手機號碼，點擊 "發送驗證碼" ，收到後輸入驗證碼，點擊 " 確認 " 查詢。',
    description_four:'如未能查驗報告，請致電 (+852) 3100 0477 向化驗所查詢。',
    description_five:'網站僅保留檢測報告一年，您的報告於發出當日起計,如已 <br> 超過一年，無法查詢。如需諮詢，請致電我們。',
    cn:'內地(86)',
    hk:'香港(00852)',
    mo:'澳門(00853)',
},

  HomeText:{
    p1_1_1:'專注',
    p1_1_1_2:'母血清基因篩選檢測',
    p1_1_2:'最早6周檢測',
    p1_1_3:'全港最快5小時出報告',
    p1_2_1:'香港醫務化驗師委員會認可',
    p1_2_1_2:'',
    p1_2_2:'香港知名品牌化驗所',
    p1_2_3:'具高端分子學檢測技術',
    p1_2_3_2:'',
    p1_3_1:'專業',
    p1_3_2:'高效',
    p1_3_3:'精準',
    p1_3_4:'優質',

    p2_title:'香港醫務檢測中心，你的首選，你的最佳選擇',
    p2_action:'更多服務項目',
    p2_item_action:'查看詳情',
    p2_1:'母血Y染色體檢測',
    p2_2:'無創產前基因檢測',
    p2_3:'親子鑑定（產前或產後）',
    p2_3_add_on:'',

    p3_title:'化驗所規格',
    p3_content:'化驗所嚴格遵照ISO 9001和ISO 17025標準和指引操作，整個實驗操作過程均有記錄，由註冊一級化驗師(HKMLT Board)進行全面嚴格監管，確保每一份化驗報告的結果是高品質，完全滿足客戶和管理要求。',

    p4_title:'榮譽與資質',
    p4_1:'香港醫務化驗師委員會認可及監管',
    p4_1_2: '',
    p4_2:'香港知名品牌化驗所',
    p4_3:'高端分子學檢測技術',

    p5_title:'科研技術',
    p5_1_1:'全自動設備',
    p5_1_2:'我們的先進實驗室儀器包括全自動DNA提取系統、高度精準的樣品處理儀器和準確的DNA檢測分析技術。全自動化的處理樣本系統能取代人工作業，務求將化驗過程中的污染問題減到最低。',
    p5_2_1:'實時聚合酶連鎖反應技術',
    p5_2_2:'我們採用最先進的實時聚合酶連鎖反應技術，把寶寶的DNA大量複製擴增和實時以螢光染劑偵測出其中是否含有Y染色體特定基因片段。在短時間內分析到最準確的結果。',
    p5_3_1:'20個獨特序列的引物',
    p5_3_2:'我們利用多達20個在Y染色體片段中的特別標記來分析最終檢測的結果。此檢測具高敏度，準確率可達99.9%。',

    p6_1:'查詢報告',
    p6_1_2:'輸入框',
    p6_1_3:'立即査詢',
    p6_2:'香港醫務檢測中心'
  },

  AboutText:{
    p1_title:'關於我們',
    p1_action:'返回主頁',

    p2_title:'公司簡介',
    p2_subtitle:'關於香港醫務檢測中心',
    p2_content:'我們以分子診斷技術和基因科技為主導。結合海外先進分子檢測設備、自主研發的尖端基因檢測技術，配合全面的資料庫和資深的科研技術團隊的分析，致力為我們寶貴的客戶提供最專業、最高端、最全面的一站式基因檢測服務。',


    p3_title:'我們的團隊',
    p3_subtitle:'專家團隊',
    p3_content:"我們的科研團隊集合了分子檢測中極具權威的專家，包括碩士級和博士級的科學顧問及具專業資格的化驗師和技術人員，他們在分子診斷領域中擁有豐富的實戰經驗。醫生顧問涵蓋科目最全醫生團隊，提供多項醫療資訊和建議。 ",

    p4_title:'企業使命',
    p4_content_1:"希望利用我們的專業知識、創新精準的基因技術及優質貼心的服務，",
    p4_content_2:"努力為每一位尊貴客戶帶來最準確而全面的檢測，從而提高下一代的生活水準。",
    p4_content_3:"我們積極與世界各地的組織合作、期望在分子檢測領域中保持領先地位、",
    p4_content_4:"加深公眾對基因檢測的認識。 ",
    p4_content_5: "",
    p4_content_6: "",
    p4_content_7: "",

    p5_title:'企業文化',
    p5_1_1:'以人為本',
    p5_1_2_1:'以顧客為先，因應客戶需求',
    p5_1_2_2:  '提供精準的基因檢測',
    p5_2_1:'關懷員工',
    p5_2_2_1:'以員工為先，為員工創造平臺',
    p5_2_2_2:  '提升個人價值',
    p5_3_1:'誠信負責',
    p5_3_2_1:'誠信待人，與客戶互相',
    p5_3_2_2:  '建立信任和負責的人際關係',
    p5_4_1:'追求卓越',
    p5_4_2_1:'持續研發創新，提升服務品質',
    p5_4_2_2:  '為社會提供卓越的產品和服務',
    p5_4_2_3:  '',
  },
  ContactUsText:{
    p1_title: '聯絡我們',
    p1_action: '返回主頁',

    p2_title:'期望與您聯繫',
    p2_action:'發送',
    p2_1:'給我們意見',
    p2_2:'你的名字',
    p2_3:'你的電話',
    p2_4:'你的電郵',

    p3_tel:'(+852) 3100 0477',
    p3_fax:'(+852) 3102 0345',
    p3_email:'info@hkmedilab.com',
    p3_address:'香港沙田鄉事會路138號新城市中央廣場1座13樓11室',
  },
  YDnaTest: {
    p1_title: '母血Y染色體檢測',
    p1_action: '返回主頁',

    p2_content: "性別除了身體特徵上的分別，在基因上也帶著決定性的差別。男性第23對染色體組合為XY；女性則是XX。",

    p3_content: "在母親懷孕初期，寶寶的遊離DNA碎片會穿過胎盤進入母親血液，這個時候可以透過採取母親血液分離出寶寶的DNA，然後利用實時聚合酶連鎖反應技術(PCR)擴增寶寶的DNA做檢測。",
    p4_content_1: "男性的Y基因是唯一只遺傳自親生父親之物質。",
    p4_content_2: "透過Y基因比對，讓我們能夠追溯父系關係。同時檢測亦可以協助父母做好Y染色體遺傳病的應對措施。",

    p5_title: "檢測方案",
    p5_1_1: "測試名稱",
    p5_1_2: "6周或以上母血Y染色體檢測",
    p5_1_3: "6周或以上母血Y染色體檢測（特快）",
    p5_2_1: "測試需時",
    p5_2_2: "1個工作日",
    p5_2_3: "5個小時",
    p5_3_1: "樣本要求",
    p5_3_2: "6mL EDTA採血管x2",
    p5_3_3: "6mL EDTA採血管x2",

    advantages_title: "測試特點",
    advantages_1_1: "加急報告",
    advantages_1_2: "全港最快5小時即日有結果",
    advantages_2_1: "高準確度",
    advantages_2_2: "準確率達99.9%",
    advantages_3_1: "高敏感度",
    advantages_3_2: "早達6周即可檢測",
    advantages_4_1: "非入侵性",
    advantages_4_2: "只需採取母血，無流產風險",

    p7_title: "檢測流程須知",
    p7_1: "預約登記",
    p7_2: "採集血液",
    p7_3: "運送樣本",
    p7_4: "樣本檢測",
    p7_5: "檢測結果",

    p8_title: "注意事項",
    p8_1_1: "若發生以下情況，",
    p8_1_2: "請在檢測前先致電診所醫護人員諮詢",

    p8_2_1: "1. 曾接受過器官移植或半年內曾接受過輸血",
    p8_2_2: "2. 半年內曾懷有男胎",
    p8_2_3: "3. 懷有多胞胎",
    p8_2_4: "4. 人工受孕",
    p8_2_5: "5. 胎兒是鑲嵌體",
  },
  NPrenatalTest: {
    p1_title: '無創產前基因檢測',
    p1_action: '返回主頁',

    p2_content: "染色體異常的精子和卵子是隨機性出現的，機率隨年紀遞增，因此每對父母均有機會誕下患有染色體異常疾病的寶寶。",
    p3_content: "此類疾病至今並無有效治療方法，但只要做好產前篩檢，就能減少誕下患病寶寶的機會。美國婦產科醫學會(ACOG)已經將非侵入性胎兒染色體基因檢測列為產前篩檢的建議項目。",
    p4_content: "無創產前檢測是目前產檢的最新技術,與傳統的入侵式產檢如絨毛活檢或羊膜穿刺等不同，只需採集母血就能獲得寶寶的基因訊息，透過先進的實時聚合酶連鎖反應(PCR)及次世代定序技術(NGS)，計算出胎兒患有染色體異常（如唐氏綜合症）的風險率，準確率高而且無流產風險。",

    p5_title: "染色體異常大致可分為三類:",
    p5_subtitle: "染色體",
    p5_1_1: "多倍體式",
    p5_1_2: "非整倍體",
    p5_2_1: "微缺失",
    p5_3_1: "基因突變",

    p6_title: "產前檢測比較",
    p6_content: "無創產前基因檢測是一項具高準確度的產前篩查技術，比傳統入侵性檢測(如絨毛活檢、羊膜穿刺等檢測)更為安全，不會導致流產和羊膜腔感染並且無流產風險，準確度高於99%。此技術只需抽取少量孕婦血液，便可檢測寶寶是否有潛在的疾病風險。",

    advantages_title: "測試特點",
    advantages_1_1: "加急報告",
    advantages_1_2: "5-7個工作日出報告",
    advantages_2_1: "高準確度",
    advantages_2_2: "準確率高達99%",
    advantages_3_1: "高敏感度",
    advantages_3_2: "早達10週即可檢測",
    advantages_4_1: "非入侵性",
    advantages_4_2: "只需採取母血，無流產風險",

    p7_1_1: "檢測名稱",
    p7_1_2: "無創產前檢測",
    p7_1_3: "羊膜穿刺",
    p7_1_4: "絨毛膜穿刺",
    p7_1_5: "胎兒頸部透明層檢查(NT)",
    p7_1_6: "早孕期篩查",
    p7_1_7: "中孕期篩查",
    p7_1_8: "臍帶靜脈穿刺",
    p7_2_1: "準確度",
    p7_2_2: ">99%",
    p7_2_3: ">99%",
    p7_2_4: ">99%",
    p7_2_5: "60%-80%",
    p7_2_6: "80%-90%",
    p7_2_7: "60%-90%",
    p7_2_8: ">99%",
    p7_3_1: "孕周(周數)",
    p7_3_2: "≥9",
    p7_3_3: "16-20",
    p7_3_4: "11-13",
    p7_3_5: "11-13",
    p7_3_6: "11-13",
    p7_3_7: "16-19",
    p7_3_8: ">20",
    p7_4_1: "流產風險",
    p7_4_2: "無",
    p7_4_3: "0.5-1%",
    p7_4_4: "1-2%",
    p7_4_5: "無",
    p7_4_6: "無",
    p7_4_7: "無",
    p7_4_8: "1-2%",
    p7_5_1: "報告週期(工作日)",
    p7_5_2: "5-7",
    p7_5_3: "14-21",
    p7_5_4: "14-21",
    p7_5_5: "1-2",
    p7_5_6: "1-2",
    p7_5_7: "1-2",
    p7_5_8: "5-7",
  },
  PaternityTest: {
    p1_title: '親子鑑定（產前或產後）',
    p1_title_2: '',
    p1_action: '返回主頁',
    p2_content: '無論男孩女孩，都有兩組染色體，一組源自父親，另一組源自母親。只需把嬰兒的染色體跟另一個體的染色體作比對，吻合的便是嬰兒的親父親母，準確率達99.99%。',

    p3_title:'產前',
    p3_subtitle:'親子鑑定',
    p3_1:'早在懷孕初期，胎兒的染色體碎片便會透過胎盤進入母親血液，最早7周母親血液內便有足夠碎片濃度作檢測，無需抽取胎兒任何組織便可檢測，比傳統抽羊水或絨毛更安全，無流產風險。',
    p3_2:'樣本：',
    p3_2_1:'靜脈血、口腔拭子、指甲、5-10根帶毛囊的頭髮',
    p3_3:'可提供檢驗的關係：',
    p3_3_1:'父子/父女',
    p4_title:'產後',
    p4_subtitle:'親子鑑定',
    p4_1:'DNA不僅可鑒定子女和父母的親子關係，還可用于鑒定親屬關係，判斷兩人之間是否存在血緣關係。',
    p4_2:'樣本：',
    p4_2_1:'靜脈血、口腔拭子、指甲、5-10根帶毛囊的頭髮',
    p4_3:'可提供檢驗的關係：',
    p4_3_1:'父子/父女',
    p4_3_2:'兄弟姊妹',
    p4_3_3:'叔侄',
    p4_3_4:'母子/母女',
    p4_3_5:'祖孫',

    advantages_title: "測試特點",
    advantages_1_1: "加急報告",
    advantages_1_2: "3-5個工作天出報告",
    advantages_2_1: "高準確度",
    advantages_2_2: "準確率達99.99%",
    advantages_3_1: "高敏感度",
    advantages_3_2: "早達7周即可檢測",
    advantages_4_1: "非入侵性",
    advantages_4_2: "只需採取母血，無流產風險(產前)",
    advantages_4_2_1: "",
  },
};
export {
  MessageTcc
}



// WEBPACK FOOTER //
// ./src/i18n/lang/tcc.js